import { render, staticRenderFns } from "./Carrusel.vue?vue&type=template&id=3143e890&scoped=true"
import script from "./Carrusel.vue?vue&type=script&lang=js"
export * from "./Carrusel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143e890",
  null
  
)

export default component.exports